<template>
  <div class="container">
		<div class="handle-container">
			<div class="search-container">
			</div>
			<div class="btn-style">
        <Button type="primary" icon="md-add" @click="openModal">添加评级</Button>
			</div>
		</div>
		<div class="table-container">
			<Table :columns="columns" :data="showList">
				<template slot-scope="{ row }" slot="action">
					<span class="edit-style" @click='handleEdit(row)'>编辑</span>
					<Poptip
						confirm
						title="确认要删除这条数据吗？"
						@on-ok="delRating(row.id)"
						transfer
					>
						<span class="del-style">删除</span>
					</Poptip>
        </template>
			</Table>
		</div>
		<div class="flex flex-justify-center">
			<Page :total="ratingList.length" :current.sync="page" :page-size="pageSize"/>
		</div>
		<ratings-modal v-model="showRatingsModal" @onSubmit="editRating" @onCancel="closeModal" :curRating="curRating"/>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import RatingsModal from './RatingsModal.vue'
import { aiFormTipsA } from '@/server/api'

export default {
	components: {
		RatingsModal,	
	},
  data() {
		return {
			showRatingsModal: false,
			curRating: undefined,
			columns: [
				{title: '评级', key: 'number'},
				{title: '自定义名称', key: 'name'},
				{title: '操作', slot: 'action'},
			],
			pageSize: 20,
			page: 1,
		}
	},
	computed: {
    ...mapState('setting', [
			'ratings',
		]),
		...mapState('scene', ['sceneId']),
		...mapState('rules', ['rules']),
		...mapState('knowledge', ['knowledge']),
		ratingList() {
			const keys = Object.keys(this.ratings);
			// 排序
			keys.sort((x, y) => y - x);
			return keys.map(key => ({
				id: key,
				number: ~~key,
				name: this.ratings[key],
			}))
		},
		showList() {
			const startIndex = (this.page - 1) * this.pageSize;
			return this.ratingList?.slice(startIndex, startIndex + this.pageSize) || [];
		},
	},
	methods: {
    ...mapActions('setting', ['updateRatings']),
		openModal() {
      this.showRatingsModal = true;
		},
		editRating({ id, name, number }) {
			const newRatings = { ...this.ratings };
			if (id) {
				delete newRatings[id]
			}
			this.updateRatings({ ...newRatings, [number]: name })
		},
		delRating(id) {
			const newRatings = { ...this.ratings };
			aiFormTipsA({
				scene_id: this.sceneId,
				intent: newRatings[id],
			}).then((res) => {
				if (res.data) {
					this.$Message.error('当前意向配置了智能表单，修改后需重新配置');
				}
			})
			if (id) {
				delete newRatings[id]
			}
			// 更新本地评级状态
			this.$store.commit('setting/SET_RATINGS', newRatings);
			// 级联清理关联数据（本地状态）
			const filteredRules = this.rules.filter(rule => !(rule.action === 'rate' && rule.action_data === `${id}`));
			if (filteredRules.length !== this.rules.length) {
				this.$store.commit('rules/SET_RULES', filteredRules);
			}
			const updatedKnowledge = this.knowledge.map(item => {
				if (`${item.rate}` === `${id}`) {
					return { ...item, rate: 0 };
				}
				return item;
			});
			this.$store.commit('knowledge/SET_KNOWLEDGE_LIST', updatedKnowledge);
			// 一次性保存：获取最新 scene，合并所有改动后保存
			this.$store.dispatch('scene/getSceneDetail').then((scene) => {
				const settingState = this.$store.state.setting;
				const newScene = {
					...scene,
					id: this.$store.state.scene.sceneId,
					version: '2.2',
					name: this.$store.state.scene.sceneName,
					settings: {
						tts: settingState.tts,
						asr: settingState.asr,
						transfer: settingState.transfer,
						sms: settingState.sms,
						vars: settingState.vars,
						general: settingState.general,
						ratings: settingState.ratings,
						apiSettings: settingState.apiSettings,
						multi_prologue: settingState.multi_prologue,
						llm: settingState.llm,
					},
					rules: filteredRules,
					knowledge: updatedKnowledge,
				};
				this.$store.dispatch('scene/saveScene', newScene);
			});
		},
		handleEdit(ratingInfo) {
			aiFormTipsA({
				scene_id: this.sceneId,
				intent: ratingInfo.name,
			}).then((res) => {
				if (res.data) {
					this.$Message.error('当前意向配置了智能表单，修改后需重新配置');
				}
			})
			this.curRating = { ...ratingInfo };
      this.openModal();
		},
		closeModal() {
			this.curRating = undefined;
		}
	}
}
</script>
<style lang="scss" scoped>
.container{
	width: 100%;
	padding: 20px;
	background-color: #fff;
	.handle-container{
		width: 100%;
		display: flex;
		justify-content: space-between;
		.btn-style{
			display: flex;
			justify-items: flex-start;
			div{
				padding: 10px 20px;
				border-radius: 20px;
				font-size: 14px;
				color: #fff;
			}
			.add-style{
				background-color: #ffa800;
				margin-right: 10px;
			}
			.export-style{
				background-color: #6186cf;
			}
			i{
				font-size: 18px;
			}
		}
	}
	.table-container{
		padding: 20px 0;
	}
	.del-style{
		color: #e72e2e;
		
	}
	.edit-style{
		display: inline-block;
		color: #6186cf;
		padding-right: 20px;
	}
}
</style>